import { AlertCircle } from 'lucide-react';

import { PageHeader } from '@@/PageHeader';
import { Widget } from '@@/Widget';
import { InformationPanel } from '@@/InformationPanel';
import { Link } from '@@/Link';

import { RepositoriesDatatable } from './RepositoriesDatatable';
import { useRepositoryViewData } from './useRepositoryViewData';

export function RepositoriesView() {
  const {
    isAdminUser,
    registry,
    showInvalidConfig,
    repositories,
    isLoading,
    breadcrumbs,
  } = useRepositoryViewData();

  return (
    <>
      <PageHeader
        title="Registry repositories"
        breadcrumbs={breadcrumbs}
        reload
      />

      {showInvalidConfig && (
        <div className="row">
          <div className="col-sm-12">
            <Widget>
              <InformationPanel title="Registry management configuration required">
                <div className="text-muted">
                  <p className="vertical-center">
                    <AlertCircle className="mr-1" size="md" />
                    Portainer was not able to use this registry management
                    feature. You might need to update the configuration used by
                    Portainer to access this registry.
                  </p>
                  <p>
                    Note: Portainer registry management features are only
                    supported with registries exposing the{' '}
                    <a
                      href="https://docs.docker.com/registry/spec/api/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      v2 registry API
                    </a>
                    .
                  </p>
                  {isAdminUser && registry && (
                    <div className="mt-2">
                      <Link
                        to="portainer.registries.registry.configure"
                        params={{ id: registry.Id }}
                        className="vertical-center"
                        data-cy="configure-registry-link"
                      >
                        <i className="fa fa-wrench mr-1" aria-hidden="true" />
                        Configure this registry
                      </Link>
                    </div>
                  )}
                </div>
              </InformationPanel>
            </Widget>
          </div>
        </div>
      )}

      <RepositoriesDatatable isLoading={isLoading} dataset={repositories} />
    </>
  );
}
